"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactFeather = require("react-feather");
var _CarouselUtils = _interopRequireDefault(require("./CarouselUtils.class"));
var _CarouselSlide = _interopRequireDefault(require("./CarouselSlide"));
var _helpers = require("../../utils/helpers");
var _CarouselModule = _interopRequireDefault(require("./../../scss/carousels/Carousel.module.scss"));
const xsmallViewport = window.matchMedia("(max-width: 600px)");
const smallViewport = window.matchMedia("(max-width: 800px");
const mediumViewport = window.matchMedia("(max-width: 1024px");
const largeViewport = window.matchMedia("(max-width: 1280px");
function Carousel(_ref) {
  let {
    id,
    slides,
    options = {
      paginationType: 'dots',
      showControls: true,
      controlArrowSize: 48,
      controlButtonsOffset: 12,
      showScrollbar: false,
      startIndex: 0,
      variableHeight: false,
      title: '',
      autoplay: false,
      autoplayDelay: 3500,
      showPagination: false,
      gutterSize: 25,
      slideAspectRatio: '4/2',
      slideGap: 1.5,
      cellsPerSlide: 1,
      cellAspectRatio: '4/2',
      cellsPosition: 'center',
      wrapAround: true
    }
  } = _ref;
  const carouselId = (0, _react.useRef)("carousel-".concat(id));
  const carouselRef = (0, _react.useRef)(null);
  const scrollerRef = (0, _react.useRef)(null);
  const paginationRef = (0, _react.useRef)(null);
  const slidesRef = (0, _react.useRef)(slides);
  const navNextRef = (0, _react.useRef)(null);
  const navPreviousRef = (0, _react.useRef)(null);
  const CarouselUtil = (0, _react.useRef)(null);
  const optionsRef = (0, _react.useRef)(options);
  const showPaginationRef = (0, _react.useRef)(options.showPagination);
  const controlsOffsetValue = (0, _react.useRef)('-50%');
  const [slidesCollection, setSlidesCollection] = (0, _react.useState)([]);
  const [responsiveOptions, setResponsiveOptions] = (0, _react.useState)(null);
  const [paginationArray, setPaginationArray] = (0, _react.useState)([]);

  /**
   * Provide overrides for user settings when
   * screen widths are too small to accomodate
   * user settings
   */
  (0, _react.useEffect)(() => {
    const checkScreenSize = function () {
      let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      if (xsmallViewport.matches) {
        setResponsiveOptions({
          ...optionsRef.current,
          showControls: false,
          showPagination: false,
          cellsPerSlide: 1,
          cellsPosition: optionsRef.current.wrapAround ? 'center' : 'flex-start',
          gutterSize: 10
        });
        optionsRef.current = {
          ...optionsRef.current,
          showControls: false,
          showPagination: false,
          cellsPerSlide: 1,
          cellsPosition: optionsRef.current.wrapAround ? 'center' : 'flex-start',
          gutterSize: 10
        };
        showPaginationRef.current = false;
      } else if (smallViewport.matches) {
        if (optionsRef.current.cellsPerSlide > 2) {
          setResponsiveOptions({
            ...optionsRef.current,
            cellsPerSlide: 2,
            showControls: false,
            gutterSize: 10
          });
          optionsRef.current = {
            ...optionsRef.current,
            cellsPerSlide: 2,
            showControls: false,
            gutterSize: 10
          };
        } else {
          setResponsiveOptions({
            ...optionsRef.current,
            showControls: false,
            gutterSize: 10
          });
          optionsRef.current = {
            ...optionsRef.current,
            showControls: false,
            gutterSize: 10
          };
        }
      } else if (mediumViewport.matches) {
        if (optionsRef.current.cellsPerSlide > 3) {
          setResponsiveOptions({
            ...optionsRef.current,
            cellsPerSlide: 3,
            showControls: false,
            gutterSize: 10
          });
          optionsRef.current = {
            ...optionsRef.current,
            cellsPerSlide: 3,
            showControls: false,
            gutterSize: 10
          };
        } else {
          setResponsiveOptions({
            ...optionsRef.current,
            showControls: false,
            gutterSize: 10
          });
          optionsRef.current = {
            ...optionsRef.current,
            showControls: false,
            gutterSize: 10
          };
        }
      } else if (largeViewport.matches && optionsRef.current.showPagination) {
        setResponsiveOptions({
          ...optionsRef.current,
          showControls: false
        });
        optionsRef.current = {
          ...optionsRef.current,
          showControls: false
        };
      } else {
        setResponsiveOptions({
          ...optionsRef.current
        });
      }
    };
    checkScreenSize();
  }, []);

  /**
   * Sets up the slides collection
   *  
   * To help achieve infinite scrolling, duplicates the last item 
   * in the array and adds it to the start of the array and duplicates 
   * the first item of the array adds it to the end of the array.
   *  
   * @param {Array} arr 
   * @returns Array
   */
  const setSlides = (0, _react.useCallback)((arr, cellsPerSlide) => {
    const chunkedSlides = (0, _helpers.chunkArray)(cellsPerSlide, arr);
    setPaginationArray([...chunkedSlides]);
    let slidesArray = [];
    for (let i = 0; i <= chunkedSlides.length - 1; i++) {
      slidesArray[i] = {};
      slidesArray[i].ariaLabel = "".concat(i + 1, " of ").concat(chunkedSlides.length);
      slidesArray[i].layout = chunkedSlides[i][0].layout;
      slidesArray[i].cells = [];
      for (let j = 0; j <= chunkedSlides[i].length - 1; j++) {
        slidesArray[i].cells[j] = {
          props: chunkedSlides[i][j].props
        };
      }
    }
    const arrClone = [...slidesArray];
    const arrWrapAroundClone = [...slidesArray];
    const lastItem = arrClone.slice(-1);
    const firstItem = arrClone.slice(0);
    arrWrapAroundClone.push(firstItem[0]);
    arrWrapAroundClone.unshift(lastItem[0]);
    return optionsRef.current.wrapAround && arr.length > cellsPerSlide ? arrWrapAroundClone : arrClone;
  }, []);
  const pauseTimer = (0, _react.useCallback)(() => {
    if (optionsRef.current.autoplay) CarouselUtil.current.clearTimer();
  }, []);

  /**
   * Handles the pressing of a key on the carousel element
   * 
   * @param {ReactEvent} e 
   */
  const handleKeyDown = (0, _react.useCallback)(e => {
    pauseTimer();
    const key = e.key;
    if (key === 'ArrowLeft') {
      e.preventDefault();
      CarouselUtil.current.determineScrollAction(-1);
    } else if (key === 'ArrowRight') {
      e.preventDefault();
      CarouselUtil.current.determineScrollAction(1);
    }
  }, [pauseTimer]);
  const handleTouchStart = (0, _react.useCallback)(e => {
    pauseTimer();
    scrollerRef.current.addEventListener('scrollend', () => {
      CarouselUtil.current.handleScrollEnd();
    }, {
      once: true
    });
  }, [pauseTimer]);
  const handleScrolling = (0, _react.useCallback)(e => {
    pauseTimer();
    scrollerRef.current.addEventListener('scrollend', () => {
      CarouselUtil.current.handleScrollEnd();
      scrollerRef.current.addEventListener('scroll', handleScrolling, {
        once: true
      });
    }, {
      once: true
    });
  }, [pauseTimer]);

  /**
   * Removes eventlisteners and clears intervals
   */
  const cleanup = () => {
    if (CarouselUtil.current && optionsRef.current.autoplay) CarouselUtil.current.clearTimer();
  };

  /**
   * Instantiate the CarouselUtils class
   */
  const initializeCarouselUtils = (0, _react.useCallback)(() => {
    //! make sure class is only instantiated once because of reacts
    //! "strict" mode double do hocus pocus
    if (CarouselUtil.current === null) {
      CarouselUtil.current = new _CarouselUtils.default({
        carouselEl: carouselRef.current,
        scrollerEl: scrollerRef.current,
        paginationEl: paginationRef.current,
        slides: slidesRef.current,
        navBtnEls: {
          next: navNextRef.current,
          previous: navPreviousRef.current
        },
        id: carouselId.current,
        options: {
          autoplay: optionsRef.current.autoplay,
          wrapAround: optionsRef.current.wrapAround && slidesRef.current.length > optionsRef.current.cellsPerSlide,
          showPagination: optionsRef.current.showPagination,
          delay: optionsRef.current.autoplayDelay,
          slideGutterSize: optionsRef.current.gutterSize,
          slideAspectRatio: optionsRef.current.slideAspectRatio,
          showControls: optionsRef.current.showControls && slidesRef.current.length > optionsRef.current.cellsPerSlide,
          cellsPerSlide: optionsRef.current.cellsPerSlide
        }
      });
    }
  }, []);
  const intializeScrollbar = (0, _react.useCallback)(() => {
    scrollerRef.current.addEventListener('scroll', handleScrolling, {
      once: true
    });
  }, [handleScrolling]);
  const initialize = (0, _react.useCallback)(() => {
    setSlidesCollection(setSlides(slidesRef.current, optionsRef.current.cellsPerSlide));
    if (slidesRef.current.length > optionsRef.current.cellsPerSlide) {
      // wait for the slides and controls to render before instantiating carousel utils when there's more than one slide
      let wait = setInterval(() => {
        if (scrollerRef.current !== null && (navPreviousRef.current !== null && optionsRef.current.showControls || !optionsRef.current.showControls)) {
          clearInterval(wait);
          intializeScrollbar();
          initializeCarouselUtils();
        }
      }, 100);
    } else {
      let wait = setInterval(() => {
        // if there's only one slide only wait for the slides to render  
        if (scrollerRef.current !== null) {
          clearInterval(wait);
          initializeCarouselUtils();
        }
      }, 100);
    }
  }, [setSlides, intializeScrollbar, initializeCarouselUtils]);

  /**
   * Sets up the slides collection and waits for slides 
   * to render before instantiating the CarouselUtils class
   */
  (0, _react.useEffect)(() => {
    if (responsiveOptions !== null) {
      if (responsiveOptions.showControls) {
        let transformOffset = 0;
        if (responsiveOptions.showPagination) transformOffset = transformOffset + 25;
        if (responsiveOptions.showScrollbar) transformOffset = transformOffset + 6;
        controlsOffsetValue.current = "calc(-50% - ".concat(transformOffset, "px)");
      }
      initialize();
    }
    return () => {
      cleanup();
    };
  }, [initialize, responsiveOptions]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, responsiveOptions !== null && /*#__PURE__*/_react.default.createElement("div", {
    className: _CarouselModule.default['carousel'],
    id: carouselId.current,
    ref: carouselRef,
    tabIndex: -1,
    role: "region",
    "aria-roledescription": "carousel",
    "aria-label": responsiveOptions.title,
    onKeyDown: handleKeyDown,
    style: {
      '--_carousel-gutters': responsiveOptions.wrapAround ? "".concat(responsiveOptions.gutterSize <= 25 ? responsiveOptions.gutterSize : 25, "%") : "0 ".concat(responsiveOptions.gutterSize <= 25 ? responsiveOptions.gutterSize : 25, "%"),
      '--_slide-aspect-ratio': responsiveOptions.slideAspectRatio,
      '--_cell-aspect-ratio': responsiveOptions.cellAspectRatio,
      '--_slide-cell-size': "".concat(100 / responsiveOptions.cellsPerSlide, "%"),
      '--_cells-position': responsiveOptions.cellsPosition,
      '--_control-btns-offset-x': "".concat(responsiveOptions.controlButtonsOffset, "rem"),
      '--_slide-gap': "".concat(responsiveOptions.slideGap, "rem"),
      '--_controls-transform': controlsOffsetValue.current
    }
  }, /*#__PURE__*/_react.default.createElement("ol", {
    className: _CarouselModule.default['carousel__scroller'],
    ref: scrollerRef,
    role: "group",
    "aria-label": "Items Scroller",
    "aria-live": "Polite",
    tabIndex: 0,
    onMouseEnter: e => {
      if (optionsRef.current.autoplay && CarouselUtil.current !== null) CarouselUtil.current.clearTimer();
    },
    onMouseLeave: e => {
      if (optionsRef.current.autoplay && CarouselUtil.current !== null) CarouselUtil.current.startTimer();
    },
    onTouchStart: handleTouchStart,
    "data-scrollbar": responsiveOptions.showScrollbar
  }, slidesCollection.length > 0 && slidesCollection.map((slide, index) => {
    return /*#__PURE__*/_react.default.createElement(_CarouselSlide.default, {
      key: "carousel".concat(id, "-slide").concat(index),
      slide: slide,
      index: index,
      currentIndex: responsiveOptions.wrapAround ? 1 : 0,
      variableHeight: responsiveOptions.variableHeight
    });
  })), responsiveOptions.showControls && slides.length > optionsRef.current.cellsPerSlide && /*#__PURE__*/_react.default.createElement("div", {
    className: _CarouselModule.default["carousel-controls"]
  }, /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    ref: navPreviousRef,
    title: "Previous Item",
    className: (0, _helpers.classes)([_CarouselModule.default['carousel-controls__btn'], _CarouselModule.default['carousel-controls__previous'], 'carousel-controls__previous']),
    "aria-controls": carouselId.current,
    "aria-label": "Previous Item",
    onClick: e => {
      CarouselUtil.current.determineScrollAction(-1);
    },
    onMouseEnter: e => {
      if (optionsRef.current.autoplay && CarouselUtil.current !== null) CarouselUtil.current.clearTimer();
    },
    onMouseLeave: e => {
      if (optionsRef.current.autoplay && CarouselUtil.current !== null) CarouselUtil.current.startTimer();
    }
  }, /*#__PURE__*/_react.default.createElement("i", {
    "aria-hidden": "true"
  }, /*#__PURE__*/_react.default.createElement(_reactFeather.ChevronLeft, {
    width: responsiveOptions.controlArrowSize,
    height: responsiveOptions.controlArrowSize
  }))), /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    ref: navNextRef,
    title: "Next Item",
    className: (0, _helpers.classes)([_CarouselModule.default['carousel-controls__btn'], _CarouselModule.default['carousel-controls__next'], 'carousel-controls__next']),
    "aria-controls": carouselId.current,
    "aria-label": "Next Item",
    onClick: e => {
      CarouselUtil.current.determineScrollAction(1);
    },
    onMouseEnter: e => {
      if (optionsRef.current.autoplay && CarouselUtil.current !== null) CarouselUtil.current.clearTimer();
    },
    onMouseLeave: e => {
      if (optionsRef.current.autoplay && CarouselUtil.current !== null) CarouselUtil.current.startTimer();
    }
  }, /*#__PURE__*/_react.default.createElement("i", {
    "aria-hidden": "true"
  }, /*#__PURE__*/_react.default.createElement(_reactFeather.ChevronRight, {
    width: responsiveOptions.controlArrowSize,
    height: responsiveOptions.controlArrowSize
  })))), showPaginationRef.current && paginationArray.length > 1 && /*#__PURE__*/_react.default.createElement("div", {
    className: [_CarouselModule.default['carousel-nav'], 'carousel-nav'].join(' ')
  }, /*#__PURE__*/_react.default.createElement("ol", {
    className: _CarouselModule.default['carousel-nav__list'],
    ref: paginationRef
  }, paginationArray.map((item, index) => {
    return /*#__PURE__*/_react.default.createElement("li", {
      className: (0, _helpers.classes)([_CarouselModule.default['carousel-nav__item'], 'carousel-nav__item']),
      "data-current": index === 0 ? "true" : "false",
      onClick: e => {
        CarouselUtil.current.navigateToIndex(index);
      },
      key: "carousel".concat(carouselId, "-nav-").concat(index),
      title: "Navigate to slide ".concat(index + 1)
    });
  })))));
}
var _default = exports.default = Carousel;